module.exports = __webpack_public_path__ + "static/scale-model-of-zootampa-at-lowry-park-in-tampa-florida-281096f495606f733ac08d64a297268b.png";